
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const FavoriteSelected = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="FavoriteSelected" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M7.96825 12.24129l4.375 2.625-.875-5.25 3.5-3.5-4.624-.639-2.376-4.611-2.37 4.611-4.63.639 3.5 3.5-.87 5.25z" />
  <path fill={colorArray[0]} className="color0"  d="M2.96825 15.86629l.998-6.03421-3.998-4.0102 5.32639-.73736L7.96925-.13371l2.67857 5.21823 5.32043.73836-3.997 4.0092 1.003 6.03321-5.005-3.01213zm5.001-4.1734l3.67063 2.21211-.73313-4.4152 2.94742-2.9564L10 6 7.96925 2.04155 5.94147 6l-3.86012.53436 2.94643 2.95541-.72917 4.41423z" />
</svg>
    </HvIconBase>
)};

FavoriteSelected.propTypes = HvIconBase.propTypes;

export default FavoriteSelected;